import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { ReturnTotalCalculations as Calculations } from "@redotech/redo-model/draft-return/draft-return";
import { Elements } from "@stripe/react-stripe-js";
import type { Stripe, StripeElements } from "@stripe/stripe-js";
import { memo } from "react";
import * as review from "../review.module.css";
import { InstantExchangeDisclaimer } from "./instant-exchange-disclaimer";
import { Payment } from "./payment";

export const InstantExchangePaymentCard = memo(
  function InstantExchangePaymentCard({
    stripe,
    setElements,
    setPaymentInfoFilled,
    submitReturn,
    settings,
    calculations,
  }: {
    stripe: Stripe;
    setElements: (elements: StripeElements) => void;
    setPaymentInfoFilled: (filled: boolean) => void;
    submitReturn: () => void;
    settings: ReturnAppSettings;
    calculations: Calculations;
  }) {
    const { newOrderValue, totalReturnValue } = calculations;
    return (
      <div className={review.summaryCard}>
        <div className={review.summaryHeader}>Instant Exchange</div>
        <InstantExchangeDisclaimer
          exchangeAmount={Math.min(newOrderValue, totalReturnValue)}
          settings={settings}
        />
        <div>
          <Elements stripe={stripe}>
            <Payment
              isInstant
              nextStep={submitReturn}
              setElements={setElements}
              setPaymentInfoFilled={setPaymentInfoFilled}
              settings={settings}
            />
          </Elements>
        </div>
      </div>
    );
  },
);
